/* unplugin-vue-components disabled */import script from "./AppFooterMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFooterMobile.vue?vue&type=script&setup=true&lang=js"

import "./AppFooterMobile.vue?vue&type=style&index=0&id=440d7937&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-440d7937"]])

export default __exports__